export default __webpack_public_path__ + "static/media/scisports-logo.c9e740c1.svg";